import { render, staticRenderFns } from "./ScanUpcBatchDialog.vue?vue&type=template&id=6136585a&scoped=true&"
import script from "./ScanUpcBatchDialog.vue?vue&type=script&lang=js&"
export * from "./ScanUpcBatchDialog.vue?vue&type=script&lang=js&"
import style0 from "./ScanUpcBatchDialog.vue?vue&type=style&index=0&id=6136585a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6136585a",
  null
  
)

export default component.exports